export default __webpack_public_path__ + "static/media/no-img.3db252d4.jpg";